import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { SelectedNodesProvider } from '@/features/connect-dots/contexts/SelectedNodesProvider';
import { TagViewContainer } from '@/features/connect-dots/components/containers/TagViewContainer';
import { FilterMirrorContainer } from '@/features/connect-dots/components/containers/FilterMirrorContainer';

export const TagViewDialog = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  const title = t('RuleWatcherタグを探索し、選択する');

  // サイドバー
  const sidebarContent = <FilterMirrorContainer onClose={onClose} />;

  // メインコンテンツ
  const mainContent = <TagViewContainer isOpen={isOpen} />;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* グレーの半透明オーバーレイ */}
      <div className="fixed inset-0 bg-black/20" aria-hidden="true" />
      <div className="fixed inset-0 p-4">
        <SelectedNodesProvider>
          <DialogPanel className="relative mx-auto flex size-full max-w-[1600px] flex-col overflow-hidden rounded-lg bg-white shadow-lg">
            {/* ヘッダー */}
            <div className="flex shrink-0 items-center justify-between border-b p-1">
              <DialogTitle className="pl-2 text-xl font-semibold">
                {title}
              </DialogTitle>
              {/* 閉じるボタン */}
              <button
                onClick={onClose}
                className="m-2 inline-flex size-9 items-center justify-center rounded-md text-rw-dark-gray transition-colors hover:bg-rw-light-gray/40"
                title={t('閉じる')}
                aria-label={t('閉じる')}
              >
                <XMarkIcon className="size-5" />
              </button>
            </div>

            {/* メインコンテンツエリア */}
            <div className="flex min-h-0 flex-1">
              {/* サイドバー */}
              <div className="h-full shrink-0 border-r bg-gray-200">
                {sidebarContent}
              </div>

              {/* メインコンテンツ */}
              <div className="min-w-0 flex-1 p-1">{mainContent}</div>
            </div>
          </DialogPanel>
        </SelectedNodesProvider>
      </div>
    </Dialog>
  );
};
